import React from 'react';
import './Footer.css';
import absImage1 from '../../Asset/Footer/pattern.png'
import absImage2 from '../../Asset/Footer/pattern (1).png'
import SkablesLogo from '../../Asset/Footer/skables.png'
import fb from '../../Asset/icon/fb.png';
import ScrollToTop from "react-scroll-to-top";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faArrowRight, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

const Footer = (props) => {
    
    return (
        <section className="footer">
            <ScrollToTop smooth top ='300'
              style={{background:"black"}}
              component={
                 <div>
                    <FontAwesomeIcon className="fs30" style={{ color: "#FF7917", }}
                    icon={faCaretUp} />
                  </div>
                } 
            />

            <div className={`footerBgUpper ${props.displayNone}`}>
                <div className="container">
                    <div className="footerBgUpperAbs">
                        <img className='absImage1' src={absImage1} alt="" />
                        <img className='absImage2' src={absImage2} alt="" />
                        <div className="w-50 m-auto">
                            <div className="text-center">
                                <h1>Skabelse Art Gallery</h1>
                                <p className='mb-4'>Discover new art and collections added weekly by our curators.</p>
                            </div>
                            <div className="input-group mb-3 ">
                                <input type="text" className="form-control" placeholder="Email Address"
                                    aria-label="Email Address" aria-describedby="basic-addon2" />
                                <button className="button px-4" type="submit">Sign Up</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footerMid ">
                <div className="container">
                    <img className='d-block m-auto px5' src={SkablesLogo} alt="" />
                </div>
            </div>
            <div className="footerMid2 d-flex flex-wrap text-center">
                <Link className="w20 bg-cl-pm py-4" to="/">
                    <img src={fb} alt="" />
                </Link>
                <Link className="w20 py-4" to="/">Instagram</Link>
                <Link className="w20 py-4" to="/">Linkedin</Link>
                <Link className="w20 py-4" to="/">Twitter</Link>
                <Link className="w20 py-4" to="/">Youtube</Link>
            </div>
            <div className="bottomFooter1">
                <div className="container">
                    <div className="d-flex py-5">
                        <div className="w20 text-white">
                            <p>For Buyers</p>
                            <ul>
                                <li><Link to="/">Art Advisory Services</Link></li>
                                <li><Link to="/">Buyer FAQ</Link></li>
                                <li><Link to="/">Return Policy</Link></li>
                                <li><Link to="/">Testimonials</Link></li>
                                <li><Link to="/">Art Prints</Link></li>
                                <li><Link to="/">Curator’s Circle</Link></li>
                                <li><Link to="/">Catalog</Link></li>
                                <li><Link to="/">Gift Card</Link></li>
                                <li><Link to="/">Refer A Friend</Link></li>

                            </ul>
                        </div>
                        <div className="w20 text-white">
                            <p>For Artists</p>
                            <ul>
                                <li><Link to="/">Why Sell</Link></li>
                                <li><Link to="/">Artist Handbook</Link></li>
                                <li><Link to="/">Profile</Link></li>
                                <li><Link to="/">Artworks</Link></li>
                                <li><Link to="/">Interviews</Link></li>
                                <li><Link to="/">Suggestions</Link></li>
                                <li><Link to="/">Artists Press</Link></li>
                            </ul>
                        </div>
                        <div className="w20 text-white">
                            <p>About Us</p>
                            <ul>
                                <li><Link to="/">About</Link></li>
                                <li><Link to="/">Press</Link></li>
                                <li><Link to="/">Career</Link></li>
                                <li><Link to="/">Contact Us</Link></li>
                                <li><Link to="/">Blog</Link></li>
                                <li><Link to="/">Stories</Link></li>
                            </ul>
                        </div>
                        <div className="w20 text-white">
                            <p>Art Gallery</p>
                            <ul>
                                <li><Link to="/">Index</Link></li>
                                <li><Link to="/allProduct">All Product</Link></li>
                                <li><Link to="/singleproduct">Single Product</Link></li>
                                <li><Link to="/artist">Artist</Link></li>
                                <li><Link to="/sartist">Single Artist</Link></li>
                                <li><Link to="/thisweek">This Week</Link></li>
                                <li><Link to="/feature">Feature</Link></li>
                            </ul>
                        </div>
                        <div className="w20 text-white">
                        <p>All Pages List</p>
                            <ul>
                                <li><Link to="/about">About</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                                <li><Link to="/forgetPassword">Forget Password</Link></li>
                                <li><Link to="/signup">Sign Up</Link></li>
                                <li><Link to="/login">Login</Link></li>
                                <li><Link to="/allblog">All Blog</Link></li>
                                <li><Link to="/singleblog">Single Blog</Link></li>
                                <li><Link to="/cart">Cart</Link></li>
                                <li><Link to="/wishlist">Wishlist</Link></li>
                                <li><Link to="/checkout">Checkout</Link></li>
                                <li><Link to="/myprofile">My Profile</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottomFooter2">
                <div className="d-flex justify-content-center align-items-center">
                    ©2022 Saatchi Art Leaf Group Commerce All Rights Reserved
                </div>
            </div>
        </section>
    );
};

export default Footer;